import { useRouter } from "next/navigation";

import { styled } from "@common/better_ui";
import Button from "@common/better_ui/src/components/Button";
import NotFound from "@common/better_ui/src/components/NotFound";
import { useIsTwistCustomer } from "lib/customer/twist/utils";

export interface NotFound404PageProps {
  message?: string;
}

const DEFAULT_MESSAGE = "The page you requested could not be found";

function TwistContent({ additionalMessage }: { additionalMessage?: string }) {
  return (
    <div style={{ textAlign: "center" }}>
      <p>
        This service is currently unavailable. Rest assured, our team is working to resolve the issue and will have it
        back up and running as soon as possible. If you need immediate assistance, please{" "}
        <a target="_blank" href="https://www.twistbioscience.com/contact" rel="noreferrer">
          reach out
        </a>
        .
      </p>
      {additionalMessage && <p>{additionalMessage}</p>}
    </div>
  );
}

export default function NotFound404Page({ message }: NotFound404PageProps) {
  const router = useRouter();
  const { isTwist } = useIsTwistCustomer();

  const customerSpecificMessage = isTwist ? <TwistContent additionalMessage={message} /> : message || DEFAULT_MESSAGE;

  return (
    <NotFound404Container>
      <NotFound
        message={customerSpecificMessage}
        extras={<StyledButton onClick={() => router.push("/")}>Return Home</StyledButton>}
      />
    </NotFound404Container>
  );
}

const NotFound404Container = styled("div")`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  padding: ${(props) => props.theme.space.large};
`;

const StyledButton = styled(Button)`
  margin-top: 10px;
`;
